// searchResults: searchByUrl(url: $path) {
//   adTargeting {
//     activity
//     areaName
//     bedsMax
//     bedsMin
//     brand
//     brandPrimary
//     countyAreaName
//     countryCode
//     currencyCode
//     listingsCategory
//     outcode
//     outcodes
//     page
//     postalArea
//     priceMax
//     priceMin
//     propertyType
//     regionName
//     resultsSort
//     searchLocation
//     searchResultsCount
//     section
//     totalResults
//     url
//     viewType
//   }
//   analyticsEcommerce {
//     currencyCode
//     impressions {
//       id
//       list
//       position
//       variant
//     }
//   }
//   analyticsTaxonomy {
//     url
//     areaName
//     activity
//     brand
//     countryCode
//     countyAreaName
//     currencyCode
//     listingsCategory
//     outcode
//     outcodes
//     page
//     postalArea
//     radius
//     radiusAutoexpansion
//     regionName
//     resultsSort
//     searchGuid
//     searchIdentifier
//     section
//     searchLocation
//     viewType
//     searchResultsCount
//     expandedResultsCount
//     totalResults
//     emailAllFormShown
//     emailAllTotalAgents
//     bedsMax
//     bedsMin
//     priceMax
//     priceMin
//     location
//     propertyType
//     geoIdentifier
//   }
//   links {
//     saveSearch
//     createAlert
//   }
//   listings {
//     regular {
//       listingId
//       price
//       priceTitle
//       shortPriceTitle
//       alternativeRentFrequencyLabel
//       priceDrop {
//         lastPriceChangeDate
//         percentageChangeLabel
//       }
//       branch {
//         branchDetailsUri
//         branchId
//         logoUrl
//         name
//         phone
//       }
//       title
//       address
//       publishedOnLabel
//       publishedOn
//       availableFrom
//       tags {
//         content
//       }
//       features {
//         content
//         iconId
//       }
//       image {
//         src
//         caption
//         responsiveImgList {
//           width
//           src
//         }
//       }
//       flag
//       transports {
//         distanceInMiles
//         lat
//         lng
//         poiType
//         title
//         features {
//           tubeLines
//           zone
//         }
//       }
//       isNewHomesDevelopment
//       isPremium
//       otherPropertyImages {
//         small
//         large
//         caption
//       }
//       highlights {
//         description
//         label
//         url
//       }
//       displayType
//       numberOfVideos
//       numberOfViews
//       numberOfImages
//       numberOfFloorPlans
//       FloatOfVideos
//       FloatOfImages
//       FloatOfFloorPlans
//       listingUris {
//         contact
//         detail
//         success
//       }
//       featuredType
//       location {
//         coordinates {
//           isApproximate
//           latitude
//           longitude
//         }
//         postalCode
//         countryCode
//         county
//         streetName
//         propertyNumberOrName
//         townOrCity
//       }
//       section
//       publicationStatus
//       lastPublishedDate
//       propertyType
//       summaryDescription
//     }
//     extended {
//       listingId
//       price
//       priceTitle
//       shortPriceTitle
//       alternativeRentFrequencyLabel
//       priceDrop {
//         lastPriceChangeDate
//         percentageChangeLabel
//       }
//       branch {
//         branchDetailsUri
//         branchId
//         logoUrl
//         name
//         phone
//       }
//       title
//       address
//       publishedOnLabel
//       publishedOn
//       availableFrom
//       tags {
//         content
//       }
//       features {
//         content
//         iconId
//       }
//       image {
//         src
//         caption
//         responsiveImgList {
//           width
//           src
//         }
//       }
//       flag
//       transports {
//         distanceInMiles
//         lat
//         lng
//         poiType
//         title
//         features {
//           tubeLines
//           zone
//         }
//       }
//       isNewHomesDevelopment
//       isPremium
//       otherPropertyImages {
//         small
//         large
//         caption
//       }
//       highlights {
//         description
//         label
//         url
//       }
//       displayType
//       numberOfVideos
//       numberOfViews
//       numberOfImages
//       numberOfFloorPlans
//       FloatOfVideos
//       FloatOfImages
//       FloatOfFloorPlans
//       listingUris {
//         contact
//         detail
//         success
//       }
//       featuredType
//       location {
//         coordinates {
//           isApproximate
//           latitude
//           longitude
//         }
//         postalCode
//         countryCode
//         county
//         streetName
//         propertyNumberOrName
//         townOrCity
//       }
//       section
//       publicationStatus
//       lastPublishedDate
//       propertyType
//       summaryDescription
//     }
//     featured {
//       listingId
//       price
//       priceTitle
//       shortPriceTitle
//       alternativeRentFrequencyLabel
//       priceDrop {
//         lastPriceChangeDate
//         percentageChangeLabel
//       }
//       branch {
//         branchDetailsUri
//         branchId
//         logoUrl
//         name
//         phone
//       }
//       title
//       address
//       publishedOnLabel
//       publishedOn
//       availableFrom
//       tags {
//         content
//       }
//       features {
//         content
//         iconId
//       }
//       image {
//         src
//         caption
//         responsiveImgList {
//           width
//           src
//         }
//       }
//       flag
//       transports {
//         distanceInMiles
//         lat
//         lng
//         poiType
//         title
//         features {
//           tubeLines
//           zone
//         }
//       }
//       isNewHomesDevelopment
//       isPremium
//       otherPropertyImages {
//         small
//         large
//         caption
//       }
//       highlights {
//         description
//         label
//         url
//       }
//       displayType
//       numberOfVideos
//       numberOfViews
//       numberOfImages
//       numberOfFloorPlans
//       FloatOfVideos
//       FloatOfImages
//       FloatOfFloorPlans
//       listingUris {
//         contact
//         detail
//         success
//       }
//       featuredType
//       location {
//         coordinates {
//           isApproximate
//           latitude
//           longitude
//         }
//         postalCode
//         countryCode
//         county
//         streetName
//         propertyNumberOrName
//         townOrCity
//       }
//       section
//       publicationStatus
//       lastPublishedDate
//       propertyType
//       summaryDescription
//     }
//   }
//   metaInfo {
//     title
//     description
//     canonicalUri
//   }
//   pagination {
//     pageNumber
//     pageNumberMax
//     totalResults
//     totalResultsWasLimited
//   }
//   savedSearchAndAlerts {
//     uri
//     currentFrequency {
//       i18NLabelKey
//       value
//     }
//   }
//   seoBlurb {
//     category
//     transactionType
//   }
//   title
//   userAlertId
// }

import * as polyline from '@mapbox/polyline';
import { fetch } from '@zoopla/data/core';
import truncate from 'lodash.truncate';
import unescape from 'lodash.unescape';
import { SearchServiceResponse } from './search.types';
import { SearchResults } from './search.result.types';

const isMapSearchLandingPage = (path: string) => {
    const landingPageRegEx = /^\/(to-rent|for-sale|new-homes)\/map\/?(\?.*)?$/;

    return landingPageRegEx.test(path);
};

const isKnownPathSegment = (segment: string): boolean => {
    const knownSegmentRegex = new RegExp(
        '^(' +
            'apartments|auction|barn-conversions|browse|bungalows|business|commercial|commercial|commercial-agents|cottages|' +
            'detached|details|developers|developments|discover|estate-agents|farms-land|find-agents|flats|for-sale|ground-floor|' +
            'home-values|hospitality|house-prices|houses|industrial-sites|land|letting-agents|map|market|new-homes|offices|' +
            'overseas|overseas|overseas-agents|' +
            'property|retail-premises|retirement|semi-detached|serviced-offices|studio|studio-flats|terraced|to-rent|' +
            '\\d-bedroom(s?)' +
            ')$'
    );

    return segment.match(knownSegmentRegex) != null;
};

export const getSearchLocationFromPath = (path?: string): string => {
    if (!path) {
        return '';
    }

    if (isMapSearchLandingPage(path)) {
        return 'uk';
    }

    /*
  Facts:
      We know the geo identifier is the last few segments of the path.
      We know after last "known" path segment from the beginning is the start of the geo identifier
  */

    // just the segments of the path
    const pathSegments = path
        .split('?')[0] // just the portion before the query character
        .replace(/^\/+/, '') // removing any lead /
        .replace(/\/+$/, '') // removing any trailing /
        .split('/'); // splitting on the internal /s

    for (let index = 0; index < pathSegments.length; index++) {
        const segment = pathSegments[index];
        // segment known?
        if (!isKnownPathSegment(segment)) {
            // add the remaining bits together...
            return pathSegments.slice(index).join('/');
        }
    }

    return path;
};

const getUrlFromPath = (path: string) => {
    const domain = 'http://zoopla.co.uk';
    const url = new URL(path, domain);
    const urlParameters = new URLSearchParams(url.search);

    return {
        url,
        urlParameters
    };
};

const getTransactionTypeKey = (path: string) =>
    path.split('/').filter(Boolean)[0];

const getTransactionType = (path: string) => {
    const transactionTypeKey = getTransactionTypeKey(path);
    const transactionTypeMap: { [key: string]: string } = {
        'for-sale': 'sale',
        'new-homes': 'sale',
        'to-rent': 'rent'
    };

    return transactionTypeMap[transactionTypeKey];
};

const transformLabels = (value: string): string => {
    // conversions that exist either for readability or SEO reasons.
    const labelsToTypeMapping = new Map<string, string>([
        ['serviced-offices', 'serviced-office'],
        ['bungalows', 'bungalow'],
        ['cottages', 'cottage'],
        ['barn-conversions', 'barn_conversion'],
        ['retail-premises', 'retail'],
        ['industrial-sites', 'industrials'],
        ['apartments', 'flats'],
        ['studio-flats', 'studio'],
        ['farms-land', 'farms_land'],
        ['semi-detached', 'semi_detached']
    ]);

    return labelsToTypeMapping.get(value) ?? value;
};

const getATypeFromPath = (url: URL, lookingForSub: boolean) => {
    const sectionRegexp =
        '(for-sale|to-rent|home-values|new-homes|overseas|find-agents|market|house-prices|discover)';
    const optionalSubsRegexp =
        '(map|developers|developments|browse|estate-agents|letting-agents|overseas-agents|commercial-agents|details)';

    const parentTypesRegexp =
        '(apartments|houses|flats|commercial|land|detached|semi-detached|' +
        'terraced|farms-land|retail-premises|industrial-sites|offices|hospitality|land)';

    const subTypesRegexp =
        '(bungalows|studio-flats|cottages|ground-floor|retirement|serviced-offices|barn-conversions)';

    const typesRegex = lookingForSub ? subTypesRegexp : parentTypesRegexp;

    const fullRegex = new RegExp(
        `/${sectionRegexp}(/commercial)?/(${optionalSubsRegexp}/)?(?<type>${typesRegex})/`
    );

    const propertyType = url.pathname.match(fullRegex);
    const value = (propertyType?.groups && propertyType?.groups['type']) || '';

    const mappedValue = transformLabels(value);

    return mappedValue || null;
};

const getAllNonEmptyParameterValues = (
    urlParameters: URLSearchParams,
    key: string
) => {
    return urlParameters.getAll(key).filter((value) => !!value);
};

const getPropertySubTypesFromParameters = (
    urlParameters: URLSearchParams
): string[] | undefined => {
    const values = getAllNonEmptyParameterValues(
        urlParameters,
        'property_sub_type'
    );
    return values.length > 0 ? values.map(transformLabels) : undefined;
};

const getPropertyTypeFromParameter = (
    urlParameters: URLSearchParams
): string | undefined => {
    const value = urlParameters.get('property_type');
    return value ? transformLabels(value) : undefined;
};

const getPropertyAndSubTypes = (url: URL, urlParams: URLSearchParams) => {
    const propertyTypeFromUrl = getATypeFromPath(url, false);
    const subPropertyTypeFromUrl = getATypeFromPath(url, true);
    const propertySubtypesFromParameters =
        getPropertySubTypesFromParameters(urlParams);
    const propertyTypeFromParameters = getPropertyTypeFromParameter(urlParams);

    let propertyType =
        propertyTypeFromParameters ?? propertyTypeFromUrl ?? undefined;
    let propertySubTypes = new Set(propertySubtypesFromParameters);

    if (subPropertyTypeFromUrl) {
        // deal with any sub types from the url, if any
        if (!propertyType || propertyType === subPropertyTypeFromUrl) {
            // look for implied property type from url sub type (if none in the url)
            const subToTypeMapping = new Map<string, string>([
                ['detached', 'houses'],
                ['semi_detached', 'houses'],
                ['terraced', 'houses'],
                ['bungalow', 'houses'],
                ['detached_bungalow', 'houses'],
                ['terraced_bungalow', 'houses'],
                ['semi_detached_bungalow', 'houses'],
                ['cottage', 'houses'],
                ['barn_conversion', 'houses'],
                ['park_home', 'houses'],
                ['houses', 'houses'],
                ['flats', 'flats'],
                ['farms_land', 'farms_land'],
                ['unserviced_office', 'offices'],
                ['serviced_office', 'offices'],
                ['offices', 'offices'],
                ['industrial', 'industrials'],
                ['light_industrial', 'industrials'],
                ['warehouse', 'industrials'],
                ['industrials', 'industrials'],
                ['retail', 'industrials'],
                ['restaurant', 'industrials'],
                ['pub_bar', 'industrials'],
                ['hotel', 'industrials'],
                ['hospitality', 'industrials'],
                ['land', 'industrials'],
                ['commercial', 'industrials']
            ]);
            propertyType = subToTypeMapping.get(subPropertyTypeFromUrl);
        }
        if (propertySubTypes) {
            propertySubTypes = propertySubTypes.add(subPropertyTypeFromUrl);
        } else {
            propertySubTypes = new Set(subPropertyTypeFromUrl);
        }
    }

    if (
        propertySubTypes.size == 1 &&
        [...propertySubTypes][0] == propertyType
    ) {
        // sometimes the property type and sub types get confused, like flats.
        propertySubTypes = new Set();
    }

    if (propertySubTypes.has('retirement')) {
        propertySubTypes.delete('retirement');
    }

    return [
        propertyType,
        propertySubTypes.size > 0 ? [...propertySubTypes] : undefined
    ];
};

const getBedrooms = (
    urlParameters: URLSearchParams,
    parameter: 'beds_max' | 'beds_min'
) => {
    const value = urlParameters.get(parameter);
    if (value !== null && value !== '') {
        return Number(value);
    } else {
        return undefined;
    }
};

const getBedroomParametersFromPath = (url: URL) => {
    const studioRegex = /\/studio\//;
    if (url.pathname.match(studioRegex)) {
        return [0, 0];
    }
    const bedroomsRegex = /(?<bedCount>\d+)-(bedrooms?)/;
    const bedroomPathMatch = url.pathname.match(bedroomsRegex);
    const bedCountValue =
        (bedroomPathMatch?.groups && bedroomPathMatch?.groups['bedCount']) ||
        '';
    if (bedCountValue) {
        return [Number(bedCountValue), Number(bedCountValue)];
    } else {
        return [undefined, undefined];
    }
};

const getBedroomParameters = (url: URL, urlParameters: URLSearchParams) => {
    const minBedrooms = getBedrooms(urlParameters, 'beds_min');
    const maxBedrooms = getBedrooms(urlParameters, 'beds_max');

    // if no params, then try the path...
    if (minBedrooms === undefined && maxBedrooms === undefined) {
        return getBedroomParametersFromPath(url);
    } else {
        return [minBedrooms, maxBedrooms];
    }
};

const getIsTriState = (urlParameters: URLSearchParams, parameter: string) => {
    const parameterValue = urlParameters.get(parameter);

    if (parameterValue === 'exclude' || parameterValue === 'false') {
        return false;
    } else if (parameterValue === 'only' || parameterValue === 'true') {
        return true;
    } else {
        return undefined;
    }
};

const getIncludeState = (urlParameters: URLSearchParams, parameter: string) => {
    const parameterValue = urlParameters.get(parameter);

    if (parameterValue === 'false') {
        return false;
    } else if (parameterValue === 'true') {
        // true means don't filter on this...
        return undefined;
    } else {
        return undefined;
    }
};

const getAuctionState = (
    url: URL,
    urlParameters: URLSearchParams,
    transactionType: string
) => {
    //in the url, trumps others
    const auctionRegex = /\/auction\//;
    if (url.pathname.match(auctionRegex)) {
        return true;
    }
    let auctionTriState = getIsTriState(urlParameters, 'is_auction');
    if (urlParameters.get('include_auctions')) {
        auctionTriState = getIncludeState(urlParameters, 'include_auctions');
    }

    return transactionType === 'sale' ? auctionTriState : undefined;
};

const getAddedAfter = (urlParameters: URLSearchParams) => {
    const added = urlParameters.get('added');

    if (!added) {
        return undefined;
    }

    const addedOptions: { [key: string]: number } = {
        '24_hours': 1,
        '3_days': 3,
        '7_days': 7,
        '14_days': 14,
        '30_days': 30
    };

    if (addedOptions[added] === undefined) {
        return undefined;
    }

    const date = new Date();
    date.setDate(date.getDate() - addedOptions[added]);

    return date.toISOString().slice(0, 19).replace('T', ' ');
};

const getAvailableFrom = (urlParameters: URLSearchParams) => {
    const availableFrom = urlParameters.get('available_from');

    if (!availableFrom) {
        return undefined;
    }

    const availableFromOptions = new Set([
        'now',
        '1months',
        '3months',
        '6months',
        '12months'
    ]);

    return availableFromOptions.has(availableFrom) ? availableFrom : undefined;
};

const getDefinedBooleanParameter = (
    urlParameters: URLSearchParams,
    parameterName: string
): boolean | undefined => {
    const val = urlParameters.get(parameterName);
    if (!val) {
        return undefined;
    }
    return val === 'true';
};

const getBillsIncluded = (urlParameters: URLSearchParams) =>
    getDefinedBooleanParameter(urlParameters, 'bills_included');

const getBranchIds = (urlParameters: URLSearchParams) => {
    const branchIds = urlParameters.getAll('branch_id');
    return branchIds?.length > 0 ? branchIds : undefined;
};

const getDefinedArrayParameter = (
    urlParameters: URLSearchParams,
    parameterName: string
): string[] | undefined => {
    const vals = urlParameters.getAll(parameterName);
    return vals.length > 0 ? vals : undefined;
};

const getBuyerIncentives = (urlParameters: URLSearchParams) =>
    getDefinedArrayParameter(urlParameters, 'buyer_incentive');

const getCategory = () => {
    // TODO: support commercial urls!
    return 'residential';
};

const getChainFree = (urlParameters: URLSearchParams) =>
    getDefinedBooleanParameter(urlParameters, 'chain_free');

const getFeatures = (urlParameters: URLSearchParams) =>
    getDefinedArrayParameter(urlParameters, 'feature');

const getDefinedStringParameter = (
    urlParameters: URLSearchParams,
    parameterName: string
): string | undefined => {
    return urlParameters.get(parameterName) ?? undefined;
};

const getFurnishedState = (urlParameters: URLSearchParams) =>
    getDefinedStringParameter(urlParameters, 'furnished_state');

const getKeywords = (urlParameters: URLSearchParams) => {
    const keywords = urlParameters.get('keywords');
    return keywords || undefined;
};

const getIncludeSold = (urlParameters: URLSearchParams) =>
    getDefinedBooleanParameter(urlParameters, 'include_sold');

const getIncludeRented = (urlParameters: URLSearchParams) =>
    getDefinedBooleanParameter(urlParameters, 'include_rented');

const getLifeCycleStatus = (
    urlParameters: URLSearchParams,
    transaction_type: string
) => {
    const lifeCycleStatuses = [
        transaction_type === 'sale' ? 'for_sale' : 'to_rent'
    ];

    if (getIncludeSold(urlParameters)) {
        lifeCycleStatuses.push('sold');
        lifeCycleStatuses.push('sale_under_offer');
    }

    if (getIncludeRented(urlParameters)) {
        lifeCycleStatuses.push('rented');
        lifeCycleStatuses.push('rent_under_offer');
    }

    return lifeCycleStatuses;
};

const getIsNewHomes = (urlParameters: URLSearchParams, path: string) => {
    const transactionTypeKey = getTransactionTypeKey(path);

    return (
        transactionTypeKey === 'new-homes' ||
        // only applicable to for-sale (unless it was in the url)
        (transactionTypeKey === 'for-sale'
            ? getIsTriState(urlParameters, 'new_homes')
            : undefined)
    );
};

const getPetsAllowed = (urlParameters: URLSearchParams) =>
    getDefinedBooleanParameter(urlParameters, 'pets_allowed');

const getCurrency = (urlParameters: URLSearchParams) =>
    getDefinedStringParameter(urlParameters, 'currency');

const getPriceFrequency = (urlParameters: URLSearchParams) =>
    getDefinedStringParameter(urlParameters, 'price_frequency');

const getPrice = (
    urlParameters: URLSearchParams,
    parameter: 'price_max' | 'price_min'
) => {
    return Number(urlParameters.get(parameter)) || undefined;
};

const getPriceReduced = (urlParameters: URLSearchParams) =>
    getDefinedBooleanParameter(urlParameters, 'reduced_price_only');

const getRadius = (urlParameters: URLSearchParams): number | null => {
    if (
        urlParameters.get('radius') !== null &&
        Number(urlParameters.get('radius')) !== 0
    ) {
        return Number(urlParameters.get('radius'));
    }

    return null;
};

const getRadiusUnit = (urlParameters: URLSearchParams) =>
    getDefinedStringParameter(urlParameters, 'radius_unit');

const getRentalTerm = (urlParameters: URLSearchParams) =>
    getDefinedStringParameter(urlParameters, 'rental_term');

const getRetirementState = (url: URL, urlParameters: URLSearchParams) => {
    const retirementRegex = /\/retirement\//;
    if (url.pathname.match(retirementRegex)) {
        return true;
    }

    let retirement = getIsTriState(urlParameters, 'is_retirement_home');
    if (urlParameters.get('include_retirement_homes')) {
        retirement = getIncludeState(urlParameters, 'include_retirement_homes');
    }
    return retirement ?? undefined;
};

const getSharedOwnershipTriState = (
    urlParameters: URLSearchParams,
    transactionType: string
) => {
    const sharedOwnershipTriState = getIsTriState(
        urlParameters,
        'is_shared_ownership'
    );

    return transactionType === 'sale' ? sharedOwnershipTriState : undefined;
};

const getSharedAccommodationState = (
    urlParameters: URLSearchParams,
    transactionType: string
) => {
    let sharedAccommodation = getIsTriState(
        urlParameters,
        'is_shared_accommodation'
    );
    if (urlParameters.get('include_shared_accommodation')) {
        sharedAccommodation = getIncludeState(
            urlParameters,
            'include_shared_accommodation'
        );
    }
    return transactionType === 'rent' ? sharedAccommodation : undefined;
};

const getIsStudentAccommodation = (
    urlParameters: URLSearchParams
): boolean | undefined => {
    const studentAccommodation = urlParameters.get('is_student_accommodation');
    if (!studentAccommodation) {
        return undefined;
    }
    return studentAccommodation === 'true';
};

const isMapSearch = (path: string): boolean => path.includes('/map/');

const getPageSize = (path: string) => (isMapSearch(path) ? 100 : 25);

const MAX_SEARCH_RESULTS = 1000;

const getPaginatedResult = (urlParameters: URLSearchParams, path: string) => {
    const pageSize = getPageSize(path);
    const currentPage = Number(urlParameters.get('pn') || '1') || 1;

    if (pageSize * currentPage > MAX_SEARCH_RESULTS) {
        throw new Error(`Max results is ${MAX_SEARCH_RESULTS}`);
    }

    return {
        from: pageSize * (currentPage - 1),
        size: pageSize
    };
};

const getSort = (urlParameters: URLSearchParams, path: string) => {
    const defaultSortOrder = getIsNewHomes(urlParameters, path)
        ? 'recommended'
        : 'newest_listings';

    const resultsSort = urlParameters.get('results_sort') ?? defaultSortOrder;

    switch (resultsSort) {
        case 'newest_listings':
            return [{ pseudo_first_published_date: { order: 'desc' } }];
        case 'most_reduced':
            return [{ price_change_pct: { order: 'asc' } }];
        case 'highest_price':
            return [{ price: { order: 'desc' } }];
        case 'lowest_price':
            return [{ price: { order: 'asc' } }];
        case 'recommended':
            return [{ recommended: { order: 'asc' } }];
    }

    return [];
};

const getListingSearchFieldSelections = (mapSearch: boolean): string[] => {
    if (mapSearch) {
        return [
            'bathrooms',
            'category',
            'content.filename',
            'content.mime_type',
            'content.original',
            'content.type',
            'derived',
            'display_address',
            'pseudo_first_published_date',
            'life_cycle_status',
            'listing_id',
            'living_rooms',
            'location.coordinates',
            'location.postal_code',
            'location.country_code',
            'new_home',
            'premium.is_premium',
            'pricing',
            'property_type',
            'retirement',
            'total_bedrooms'
        ];
    }
    return [
        'available_from_date',
        'bathrooms',
        'branch',
        'branch_id',
        'business_for_sale',
        'buyer_incentives',
        'category',
        'content.caption',
        'content.filename',
        'content.mime_type',
        'content.original',
        'content.type',
        'derived',
        'display_address',
        'pseudo_first_published_date',
        'last_published_date',
        'life_cycle_status',
        'listing_id',
        'living_rooms',
        'location.coordinates',
        'location.postal_code',
        'location.country_code',
        'new_home',
        'premium.highlights',
        'premium.is_premium',
        'pricing',
        'property_type',
        'retirement',
        'summary_description',
        'tenant_eligibility',
        'total_bedrooms'
    ];
};

type Parameters = {
    auction?: boolean;
    added_after?: string;
    available_from?: string;
    beds_max?: number;
    beds_min?: number;
    bills_included?: boolean;
    branch_ids?: string[];
    buyer_incentives?: string[];
    category?: string;
    chain_free?: boolean;
    features?: string[];
    furnished_state?: string;
    keywords?: string;
    life_cycle_status: string[];
    new_homes?: boolean;
    pets_allowed?: boolean;
    price_currency?: string;
    price_frequency?: string;
    price_max?: number;
    price_min?: number;
    price_reduced?: boolean;
    property_sub_types?: string | string[];
    property_type?: string | string[];
    radius?: number | null;
    radius_unit?: string;
    rental_term?: string;
    retirement?: boolean;
    shared_ownership?: boolean;
    shared_accommodation?: boolean;
    student_accommodation?: boolean;
    transaction_type: string;
};

type ExtendedParameters = Omit<
    Parameters,
    'life_cycle_status' | 'transaction_type'
> & {
    life_cycle_status?: string[];
    transaction_type?: string;
    centre?: [number, number];
};

const mapSearchUrlToSearchServiceParameters = (
    path: string,
    preferredFields?: string[]
) => {
    const { url, urlParameters } = getUrlFromPath(path);
    const transactionType = getTransactionType(path);
    const [propertyType, propertySubTypes] = getPropertyAndSubTypes(
        url,
        urlParameters
    );
    const [bedRoomMin, bedRoomMax] = getBedroomParameters(url, urlParameters);

    const parameters: Parameters = {
        auction: getAuctionState(url, urlParameters, transactionType),
        added_after: getAddedAfter(urlParameters),
        available_from: getAvailableFrom(urlParameters),
        beds_max: bedRoomMax,
        beds_min: bedRoomMin,
        bills_included: getBillsIncluded(urlParameters),
        branch_ids: getBranchIds(urlParameters),
        buyer_incentives: getBuyerIncentives(urlParameters),
        category: getCategory(),
        chain_free: getChainFree(urlParameters),
        features: getFeatures(urlParameters),
        furnished_state: getFurnishedState(urlParameters),
        keywords: getKeywords(urlParameters),
        life_cycle_status: getLifeCycleStatus(urlParameters, transactionType),
        new_homes: getIsNewHomes(urlParameters, path),
        pets_allowed: getPetsAllowed(urlParameters),
        price_currency: getCurrency(urlParameters),
        price_frequency: getPriceFrequency(urlParameters),
        price_max: getPrice(urlParameters, 'price_max'),
        price_min: getPrice(urlParameters, 'price_min'),
        price_reduced: getPriceReduced(urlParameters),
        property_sub_types: propertySubTypes,
        property_type: propertyType,
        radius: getRadius(urlParameters),
        radius_unit: getRadiusUnit(urlParameters),
        rental_term: getRentalTerm(urlParameters),
        retirement: getRetirementState(url, urlParameters),
        shared_ownership: getSharedOwnershipTriState(
            urlParameters,
            transactionType
        ),
        shared_accommodation: getSharedAccommodationState(
            urlParameters,
            transactionType
        ),
        student_accommodation: getIsStudentAccommodation(urlParameters),
        transaction_type: transactionType
    };

    const { from, size } = getPaginatedResult(urlParameters, path);
    const sort = getSort(urlParameters, path);
    const fields =
        preferredFields ?? getListingSearchFieldSelections(isMapSearch(path));
    return {
        from,
        fields,
        size,
        parameters,
        sort
    };
};

const getPolyEncParameters = (path: string, parameterRadius: number | null) => {
    const domain = 'http://zoopla.co.uk';
    const url = new URL(path, domain);
    const urlParameters = new URLSearchParams(url.search);
    const values = getDefinedArrayParameter(urlParameters, 'polyenc');
    if (values !== undefined) {
        return {
            polyEncValues: values,
            radius: parameterRadius ?? 0
        };
    }
    return null;
};

const ensureClosedPolygon = (
    coords: [number, number][]
): [number, number][] => {
    if (coords.length < 3) {
        throw new Error('Polyenc data does not contain enough points');
    }
    if (coords[0] !== coords.slice(-1)[0]) {
        // alas, no Array.at
        coords.push(coords[0]);
    }
    return coords;
};

const generatePolygonPointsFromPolyenc = (
    polyEncValue: string
): [number, number][] => {
    // undoing what the UI does:
    // https://gitlab.com/zoopla/frontend/app-react/-/blob/59078df7/libs/listing-search/map-view/src/lib/components/SearchMapViewPage/utils/generatePolyenc.ts#L20
    const decoded = decodeURIComponent(polyEncValue);
    let points = polyline.decode(decoded, 5);
    // note switch of lat/lon from google maps to geojson style
    points = points.map((point) => [point[1], point[0]]);
    // make sure the polygon is closed
    points = ensureClosedPolygon(points);
    return points;
};

const generateGeoJsonStructure = (polyEncValues: string[]) => {
    const polygonPointsList = polyEncValues.map((x) =>
        generatePolygonPointsFromPolyenc(x)
    );
    if (polygonPointsList.length == 1) {
        return {
            coordinates: [polygonPointsList[0]],
            type: 'Polygon'
        };
    } else {
        return {
            coordinates: polygonPointsList.map((x) => [x]),
            type: 'MultiPolygon'
        };
    }
};

type PolyEncParameters = {
    polyEncValues: string[];
    radius: number;
};

// TODO: autogen
type GeoLocationServiceResponse = {
    expanded_polygon?: unknown;
};

const getPolygonFromPolyEncSearchArgs = async (
    polyEncParameters: PolyEncParameters
) => {
    const initialPolygon = generateGeoJsonStructure(
        polyEncParameters.polyEncValues
    );

    if (!process.env.API_GEO_LOCATION || !process.env.API_GEO_LOCATION_SECRET) {
        throw new Error(
            'Missing API_GEO_LOCATION or API_GEO_LOCATION_SECRET envar'
        );
    }

    if (polyEncParameters.radius > 0) {
        const url = new URL(
            `${process.env.API_GEO_LOCATION}/api/v1/polygon/expand`
        );
        const expandPolygonResult = await fetch<GeoLocationServiceResponse>(
            {
                url,
                secret: process.env.API_GEO_LOCATION_SECRET
            },
            JSON.stringify({
                miles: polyEncParameters.radius,
                polygon: initialPolygon
            })
        );

        if ('expanded_polygon' in expandPolygonResult) {
            return {
                polygon: expandPolygonResult.expanded_polygon,
                radius: undefined
            };
        } else {
            // logger.error(expandPolygonResult);
            // initial polygon will be used instead
        }
    }

    return {
        polygon: initialPolygon,
        radius: undefined
    };
};

const getSearchArgsForPostcode = (
    geoData: { geoType?: string; coordinates?: Coordinates },
    radius: number
): { centre: [number, number]; radius: number } | undefined => {
    if (geoData.geoType === 'postcode' && radius > 0 && geoData.coordinates) {
        return {
            centre: [geoData.coordinates.lng, geoData.coordinates.lat],
            radius
        };
    }

    return;
};

const getSearchArgsForOutcode = (
    geoData: { geoType?: string; outcode?: string | null },
    radius: number
) => {
    if (geoData.geoType === 'outcode' && radius === 0) {
        return {
            outcode: geoData.outcode
        };
    }
};

const getSearchArgsForPostcodeSector = (
    geoData: { geoType?: string; outcode?: string | null; incode?: string },
    radius: number
): {
    outcode?: string | null;
    incode?: string;
} | null => {
    if (
        (geoData.geoType === 'postcode_sector' ||
            geoData.geoType === 'postcode') &&
        !radius
    ) {
        return {
            outcode: geoData.outcode,
            incode: geoData.incode
        };
    }

    return null;
};

const DEFAULT_SEARCH_RADIUS = 0.5;
const getSearchArgsForAliasPoint = (
    geoData: {
        geoType?: string;
        aliasType?: string;
        coordinates?: Coordinates;
    },
    radius: number
): { centre: [number, number]; radius: number } | null => {
    if (
        geoData.geoType === 'alias' &&
        geoData.aliasType === 'point' &&
        geoData.coordinates
    ) {
        return {
            centre: [geoData.coordinates.lng, geoData.coordinates.lat],
            radius: radius || DEFAULT_SEARCH_RADIUS
        };
    }

    return null;
};

const getSearchArgsForAreaStreet = (
    geoData: {
        geoType?: string;
        areaStreetId?: number;
        dependentStreetIds?: number[];
        coordinates?: Coordinates;
    },
    radius: number
): {
    area_street_ids: number[];
    centre?: [number, number];
    radius?: number;
} | null => {
    if (geoData.geoType === 'area_street' && geoData.areaStreetId) {
        const areaStreetIds = geoData.dependentStreetIds
            ? [geoData.areaStreetId].concat(geoData.dependentStreetIds)
            : [geoData.areaStreetId];

        if (radius && geoData.coordinates) {
            return {
                area_street_ids: areaStreetIds,
                centre: [geoData.coordinates.lng, geoData.coordinates.lat],
                radius
            };
        } else {
            return {
                area_street_ids: areaStreetIds
            };
        }
    }

    return null;
};

const getSearchArgsForUK = (geoData: {
    geoType?: string;
    areaName?: string;
}) => {
    if (!geoData.geoType && geoData.areaName === 'UK') {
        return {
            // NOTE: not required to be specified as 'gb' is the default
            // countryCode: 'gb'
            radius: undefined
        };
    }
};

type Position = [number, number];
type LinearRing = Position[];
type PolygonCoords = LinearRing[];
type MultiPolygonCoords = PolygonCoords[];

type GeoJsonPolygon = {
    type: 'Polygon';
    coordinates: PolygonCoords;
};

type GeoJsonMultiPolygon = {
    type: 'MultiPolygon';
    coordinates: MultiPolygonCoords;
};

export type GeoJsonAnyPolygon = GeoJsonPolygon | GeoJsonMultiPolygon;

type RadiiMiles =
    | '0'
    | '0.25'
    | '0.5'
    | '1'
    | '3'
    | '5'
    | '10'
    | '15'
    | '20'
    | '30'
    | '40';

type Polygons = {
    [key in RadiiMiles]: GeoJsonAnyPolygon;
};

function stringToRadius(s: string): RadiiMiles | null {
    switch (s) {
        case '0':
        case '0.25':
        case '0.5':
        case '1':
        case '3':
        case '5':
        case '10':
        case '15':
        case '20':
        case '30':
        case '40':
            return s;
    }

    return null;
}

const getSearchArgsForPolygon = (
    geoData: { coordinates?: unknown; polygons?: Polygons },
    radius: number
) => {
    if (!geoData.polygons) {
        return;
    }

    const r = stringToRadius(String(radius));

    if (r === null) {
        return;
    }

    const polygon = geoData.polygons[r];

    return {
        polygon,
        radius: undefined,
        radius_unit: undefined
    };
};

interface Coordinates {
    lat: number;
    lng: number;
}

/*
Remove?
- aliasId
- areaId
- countryId
- countyAreaId
- entityIdField
- laCode
- level
- postTownId
- regionId
 */
interface LegacyGeoData {
    areaName?: string;
    areaStreetId?: number;
    coordinates?: Coordinates;
    countryCode?: string; // check with Elliott
    countyAreaName?: string;
    dependentStreetIds?: Array<number>; // check with Elliott
    fullAreaName?: string; // check with Elliott
    geoType?: string;
    identifier?: string;
    incode?: string; // check with Elliott
    outcode?: string | null;
    polygons?: Polygons;
    postalArea?: string | null;
    postTownName?: string; // check with Elliott
    regionName?: string;
}

type LegacyGeoDataDTO = {
    geoData: LegacyGeoData;
};

const mapGeoDataToSearchArgs = (
    geoDataResponse: LegacyGeoDataDTO,
    parameterRadius?: number | null
) => {
    const { geoData } = geoDataResponse;
    const radius = parameterRadius ?? 0;

    const searchArgs =
        getSearchArgsForPostcode(geoData, radius) ||
        getSearchArgsForOutcode(geoData, radius) ||
        getSearchArgsForPostcodeSector(geoData, radius) ||
        getSearchArgsForAliasPoint(geoData, radius) ||
        getSearchArgsForAreaStreet(geoData, radius) ||
        getSearchArgsForUK(geoData) ||
        getSearchArgsForPolygon(geoData, radius);

    if (searchArgs) {
        return searchArgs;
    } else {
        throw new Error('Geo Data Response invalid');
    }
};

type SearchServiceRequest = {
    from: number;
    size: number;
    sort: (
        | { pseudo_first_published_date: { order: string } }
        | { price_change_pct: { order: string } }
        | { price: { order: string } }
        | { recommended: unknown }
    )[];
    fields: string[];
    featured: boolean;
    parameters: Parameters;
    extended?: unknown;
};

const EXTENDED_SEARCH_RADIUS = 40;
const MIN_RESULT_COUNT = 10;

const clearProps = new Set([
    'polygon',
    'radius',
    'incode',
    'outcode',
    'centre',
    'area_street_ids'
]);

// TODO: how do we get an alias type?
const generateFallbackExtendedSearch = (
    initialSearchRequest: SearchServiceRequest,
    geoDataResponse: {
        geoData: { aliasType?: string; coordinates: Coordinates };
    }
) => {
    if (
        // check there is no radius specified (and account for point aliases)
        (!initialSearchRequest.parameters?.radius ||
            (geoDataResponse.geoData.aliasType === 'point' &&
                initialSearchRequest.parameters?.radius ===
                    DEFAULT_SEARCH_RADIUS)) &&
        initialSearchRequest.from === 0 // only try extending on the first page
    ) {
        // check we got a lat/lon
        if (geoDataResponse.geoData?.coordinates) {
            const coordinates = geoDataResponse.geoData?.coordinates;
            // const extendedSearchParams = cloneDeep(
            //     initialSearchRequest.parameters
            // );

            const extendedParams: ExtendedParameters = {};

            Object.entries(initialSearchRequest.parameters).forEach(
                ([k, v]) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (!clearProps.has(k)) extendedParams[k] = v;
                }
            );

            extendedParams.radius = EXTENDED_SEARCH_RADIUS;
            extendedParams.centre = [coordinates.lng, coordinates.lat];
            return {
                parameters: extendedParams,
                initial_search_min_count: MIN_RESULT_COUNT,
                reapply_initial_sort: true,
                sort: [
                    {
                        distance: {
                            coordinates: [coordinates.lng, coordinates.lat],
                            order: 'asc'
                        }
                    }
                ]
            };
        } else {
            // We should review these log messages, and see for which geo-identifiers this happens.
            // logger.error(
            //     `unable to add fall-back search option to request because geo-identifier(${geoDataResponse.geoData.identifier}) has no lat/lon`
            // );
            return undefined;
        }
    }
    return undefined;
};

const sha256Hex = (content: string): string => {
    if (!('createHash' in crypto)) return crypto.randomUUID();

    // Unfortunately we're reusing the same code on both the edge and in a Node.js
    // runtime which isn't easy to express in TS
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return crypto.createHash('sha256').update(content).digest('hex');
};

// cost: ~9ms -> ~20ms
// TODO: Elliott to think about GUID
const generateSearchIdentifier = (searchUri: string): string => {
    const baseUrl = 'http://zoopla.co.uk';
    const HASH_SALT = 'a9b52ca6b8cb4f73a58184ea59dac508'; // random string

    const url = new URL(searchUri, baseUrl);
    url.searchParams.sort();
    const sortedUri = url.toString().slice(baseUrl.length);
    return sha256Hex(HASH_SALT + sortedUri);
};

type Listing = {
    listing_id: number;
    premium?: { highlights?: { length: number }; is_premium?: boolean };
    location?: { country_code?: string; postal_code?: string };
    pricing?: { currency_code?: string };
};

const getVariant = (listing?: Listing) => {
    if (listing?.premium?.highlights?.length) {
        return 'premium_plus';
    } else if (listing?.premium?.is_premium) {
        return 'premium';
    }

    return 'standard';
};

const isPriceOnRequest = (listingJson: ListingJson) => {
    const { pricing } = listingJson;

    return (
        pricing?.price_qualifier === 'price_on_request' &&
        isNewHome(listingJson)
    );
};

function getPrice2(listingJson: ListingJson) {
    const { pricing } = listingJson;

    if (!pricing) {
        return null;
    }

    if (isPriceOnRequest(listingJson)) {
        return 'POA';
    }

    if (pricing.transaction_type === 'rent') {
        return `£${pricing?.rent_values?.per_month?.price?.toLocaleString()} pcm`;
    }

    return `£${pricing?.price?.toLocaleString()}`;
}

// cost ~0.5ms
const getAnalyticsEcommerce = (response: { listings: Listing[] }) => ({
    currencyCode: 'GBP',
    // event: 'pageshow', not selected by GraphQL
    impressions: response.listings?.map((listing, index) => ({
        id: Number(listing?.listing_id),
        list: 'Search results',
        position: index + 1,
        variant: getVariant(listing)
    }))
});

const getMostCommonCountryCode = (response: { listings: Listing[] }) => {
    const countryCodeFrequency = new Map();
    let mostCommonCountryCode = '';
    let highestFrequency = 0;

    response?.listings?.forEach((listing) => {
        const countryCode = listing?.location?.country_code ?? '';
        if (countryCode) {
            countryCodeFrequency.set(
                countryCode,
                (countryCodeFrequency.get(countryCode) || 0) + 1
            );
            if (countryCodeFrequency.get(countryCode) > highestFrequency) {
                mostCommonCountryCode = countryCode;
                highestFrequency = countryCodeFrequency.get(countryCode);
            }
        }
    });

    return mostCommonCountryCode.toLowerCase();
};

const getMostCommonCurrencyCode = (response: { listings: Listing[] }) => {
    const currencyCodeFrequency = new Map();
    let mostCommonCurrencyCode = '';
    let highestFrequency = 0;

    response.listings?.forEach((listing) => {
        const currencyCode = listing?.pricing?.currency_code ?? '';
        if (currencyCode) {
            currencyCodeFrequency.set(
                currencyCode,
                (currencyCodeFrequency.get(currencyCode) || 0) + 1
            );
            if (currencyCodeFrequency.get(currencyCode) > highestFrequency) {
                mostCommonCurrencyCode = currencyCode;
                highestFrequency = currencyCodeFrequency.get(currencyCode);
            }
        }
    });

    return mostCommonCurrencyCode;
};

const getMostCommonOutcode = (response: { listings: Listing[] }) => {
    const outcodeFrequency = new Map();
    let mostCommonOutcode = '';
    let highestFrequency = 0;

    response?.listings?.forEach((listing) => {
        const postcode = listing?.location?.postal_code;
        if (postcode) {
            const outcode = postcode.split(' ')[0];
            const frequency = (outcodeFrequency.get(outcode) || 0) + 1;
            outcodeFrequency.set(outcode, frequency);
            if (frequency > highestFrequency) {
                mostCommonOutcode = outcode;
                highestFrequency = frequency;
            }
        }
    });

    return mostCommonOutcode;
};

const getListingCategory = (path: string): string => {
    const isCommercial = /\/commercial\//i.test(path);

    return isCommercial ? 'commercial' : 'residential';
};

const getAllOutcodes = (response: { listings: Listing[] }) => {
    const outcodes = new Set<string>();

    response.listings?.forEach((listing) => {
        const postcode = listing?.location?.postal_code;
        if (postcode) {
            outcodes.add(postcode.split(' ')[0]);
        }
    });

    return Array.from(outcodes);
};

const getSearchLocation = (urlParameters: URLSearchParams) => {
    return urlParameters.get('q');
};

const getPage = (path: string) => {
    return `/${getTransactionTypeKey(path)}/results/`;
};

const getPostalArea = (response: { listings: Listing[] }) => {
    const postcode = response?.listings?.[0]?.location?.postal_code;

    return postcode?.match(/^[a-zA-Z][a-zA-Z]?/)?.[0] ?? '';
};

const getViewType = (urlParameters: URLSearchParams) => {
    return urlParameters.get('viewType') === 'Map' ? 'Map' : 'List';
};

type GetAnalyticsTaxonomyProps = {
    geoData: {
        areaName: string;
        identifier: string;
        outcode: string | null;
        countyAreaName: string;
        regionName?: string;
    };
    response: {
        listings: Listing[];
        total: number;
    };
    requestUrl: string;
    resultsSort: string;
    searchGuid: string;
    searchIdentifier: string;
};

// cost: ~18ms -> ~50ms
const getAnalyticsTaxonomy = ({
    geoData,
    response,
    requestUrl,
    resultsSort,
    searchGuid,
    searchIdentifier
}: GetAnalyticsTaxonomyProps) => {
    const domain = 'http://zoopla.co.uk';
    const url = new URL(requestUrl, domain);
    const urlParameters = new URLSearchParams(url.search);
    const [bedRoomMin, bedRoomMax] = getBedroomParameters(url, urlParameters);
    const priceMax = getPrice(urlParameters, 'price_max');
    const priceMin = getPrice(urlParameters, 'price_min');
    const {
        areaName,
        identifier: geoIdentifier,
        outcode,
        countyAreaName,
        regionName
    } = geoData || {};

    return {
        activity: 'listing_search',
        areaName,
        bedsMax: bedRoomMax ? String(bedRoomMax) : null,
        bedsMin: bedRoomMin ? String(bedRoomMin) : null,
        brand: 'zoopla',
        countryCode: getMostCommonCountryCode(response),
        countyAreaName: countyAreaName ?? null,
        currencyCode: getMostCommonCurrencyCode(response),
        expandedResultsCount: 0, // Todo: implement when radius expand has been implemented
        geoIdentifier,
        listingsCategory: getListingCategory(requestUrl),
        outcode: outcode || getMostCommonOutcode(response),
        outcodes: getAllOutcodes(response),
        page: getPage(requestUrl),
        postalArea: getPostalArea(response),
        priceMax: priceMax ? String(priceMax) : null,
        priceMin: priceMin ? String(priceMin) : null,
        radius: getRadius(urlParameters),
        regionName: regionName ?? null,
        resultsSort,
        searchGuid,
        searchIdentifier,
        searchLocation: getSearchLocation(urlParameters),
        searchResultsCount: response.total,
        section: getTransactionTypeKey(requestUrl),
        totalResults: response.total,
        url: requestUrl,
        viewType: getViewType(urlParameters)
    };
};

// cost: ~3ms
const getMediaContentCount = (listingJson: {
    content?: { type?: string }[];
}) => {
    const mediaContentCount = {
        numberOfVideos: 0,
        numberOfImages: 0,
        numberOfFloorPlans: 0
    };

    listingJson.content?.forEach((currentMediaContent) => {
        if (!currentMediaContent) {
            return;
        }

        switch (currentMediaContent.type) {
            case 'floor_plan':
                mediaContentCount.numberOfFloorPlans += 1;
                break;
            case 'property_image':
                mediaContentCount.numberOfImages += 1;
                break;
            case 'virtual_tour':
                mediaContentCount.numberOfVideos += 1;
                break;
        }

        return mediaContentCount;
    });

    return mediaContentCount;
};

const getPriceTitle = (listingJson: {
    pricing?: { price_qualifier?: string };
}): string => {
    if (!listingJson.pricing?.price_qualifier) {
        return '';
    }

    switch (listingJson?.pricing?.price_qualifier) {
        case 'coming_soon':
            return 'Coming soon';
        case 'fixed_price':
            return 'Fixed price';
        case 'from':
            return 'From';
        case 'guide_price':
            return 'Guide price';
        case 'non_quoting':
            return 'Non quoting';
        case 'offers_in_region_of':
            return 'Offers in region of';
        case 'offers_over':
            return 'Offers over';
        case 'sale_by_tender':
            return 'Sale by tender';
    }

    return '';
};

const isOverOneMillion = (price: number) => price >= 1000000;
const isOverOneHundredThousand = (price: number) => price >= 100000;
const isOverTenThousand = (price: number) => price >= 10000;
const isOverOneThousand = (price: number) => price >= 1000;
const isUnderOneThousand = (price: number) => price <= 1000;

const getNumberToDivide = (price: number) => {
    if (isOverOneMillion(price)) {
        return 1000000;
    } else if (isOverOneThousand(price)) {
        return 1000;
    } else {
        return 1;
    }
};

const roundToNoDecimalPlaces = (price: number) =>
    Math.round(price + Number.EPSILON);

const roundToTwoDecimalPlaces = (price: number) =>
    Math.round((price + Number.EPSILON) * 100) / 100;

const roundToFiftyThousand = (price: number) =>
    Math.round((price + Number.EPSILON) / 0.05) * 0.05;

const getPostfix = (price: number) => {
    if (isOverOneMillion(price)) {
        return 'm';
    } else if (isOverOneThousand(price)) {
        return 'k';
    } else {
        return '';
    }
};

const roundingOverOneMillion = (price: number) => {
    const roundingNumber = price / getNumberToDivide(price);
    const result = roundToFiftyThousand(roundingNumber);
    const roundedResult = roundToTwoDecimalPlaces(result);
    return roundedResult + getPostfix(price);
};

const roundingUnderOneMillion = (price: number) => {
    const roundingNumber = price / getNumberToDivide(price);
    const result = roundToNoDecimalPlaces(roundingNumber);
    return result + getPostfix(price);
};

const roundingOverTenThousand = (price: number) => {
    const roundingNumber = price / 1000;
    const result = roundToTwoDecimalPlaces(roundingNumber);
    return result + getPostfix(price);
};

const getValue = (input: number) => {
    if (isOverOneMillion(input)) {
        return `£${roundingOverOneMillion(input)}`;
    } else if (isOverOneHundredThousand(input)) {
        return `£${roundingUnderOneMillion(input)}`;
    } else if (isOverTenThousand(input)) {
        return `£${roundingOverTenThousand(input)}`;
    } else if (isOverOneThousand(input)) {
        return `£${input}`;
    } else {
        isUnderOneThousand(input);
        return `£${roundingUnderOneMillion(input)}`;
    }
};

const buildShortPriceTitle = (qualifier: string, price: number) => {
    if (qualifier === 'sale_by_tender') {
        return 'SBT';
    }
    return getValue(price);
};

function getAlternativeRentFrequencyLabel(listingJson: {
    pricing?: { rent_values?: { per_week?: { price?: string } } };
}) {
    if (!listingJson.pricing?.rent_values?.per_week?.price) {
        return null;
    }

    return `£${listingJson.pricing?.rent_values?.per_week?.price.toLocaleString()} pw`;
}

function getCorrectPhoneForListing(listingJson: {
    branch?: {
        redirect_commercial_phone?: string;
        redirect_lettings_phone?: string;
        redirect_phone?: string;
    };
    category?: string;
    pricing?: {
        transaction_type?: string;
    };
}) {
    const branch = listingJson.branch;
    if (
        listingJson.category === 'commercial' &&
        branch?.redirect_commercial_phone
    ) {
        return branch.redirect_commercial_phone;
    }

    if (
        listingJson.pricing?.transaction_type === 'rent' &&
        branch?.redirect_lettings_phone
    ) {
        return branch.redirect_lettings_phone;
    }
    return branch?.redirect_phone ?? null;
}

function percentageDifference(
    previousPrice?: number | null,
    currentPrice?: number | null
) {
    if (!previousPrice || !currentPrice || currentPrice >= previousPrice) {
        return null;
    }

    const priceChange = currentPrice - previousPrice;

    const percentage = Math.abs(100 * (priceChange / previousPrice));

    if (percentage < 0.1) {
        return '< 0.1';
    }

    return percentage.toFixed(1);
}

const englishOrdinalSuffix = (dt: Date): string => {
    const day: number = dt.getDate();
    const stSuffix: string | null = day % 10 === 1 && day !== 11 ? 'st' : null;
    const ndSuffix: string | null = day % 10 === 2 && day !== 12 ? 'nd' : null;
    const rdSuffix: string | null = day % 10 === 3 && day !== 13 ? 'rd' : null;
    const suffix: string = stSuffix || ndSuffix || rdSuffix || 'th';
    return `${day}${suffix}`;
};

// cost: ~0.3ms but seems to have a huge saving overall...200ms?
const dateStringResolver = (date: Date) => {
    if (isNaN(Number(date))) {
        return '';
    }

    const day = englishOrdinalSuffix(date);

    const month = date.toLocaleString('default', { month: 'long' }).slice(0, 3);

    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

const getPriceDrop = (listingJson: {
    pricing?: {
        pricing_history?: {
            price?: number;
            batch_creation_date?: string;
        }[];
    };
}) => {
    const pricingHistory = listingJson.pricing?.pricing_history || [];

    pricingHistory.sort(
        (a, b) =>
            new Date(a?.batch_creation_date ?? '').getTime() -
            new Date(b?.batch_creation_date ?? '').getTime()
    );

    const currentPrice = pricingHistory.pop();
    const previousPrice = pricingHistory.pop();

    const percentageChangeLabel = percentageDifference(
        previousPrice?.price,
        currentPrice?.price
    );

    return {
        lastPriceChangeDate: currentPrice?.batch_creation_date
            ? dateStringResolver(new Date(currentPrice?.batch_creation_date))
            : '',
        percentageChangeLabel
    };
};

const propertyTypes: { [key: string]: string } = {
    barn_conversion: 'barn conversion',
    block_of_flats: 'block of flats',
    bungalow: 'bungalow',
    business_park: 'business park',
    chalet: 'chalet',
    chateau: 'château',
    cottage: 'cottage',
    country_house: 'country house',
    detached: 'detached house',
    detached_bungalow: 'detached bungalow',
    end_terrace: 'end terrace house',
    equestrian: 'equestrian',
    farm: 'farm',
    farm_barn: 'barn conversion/farmhouse',
    farmhouse: 'farmhouse',
    finca: 'finca',
    flat: 'flat',
    hotel: 'hotel',
    houseboat: 'houseboat',
    industrial: 'industrial',
    junk: 'unknown',
    land: 'land',
    leisure: 'leisure/hospitality',
    light_industrial: 'light industrial',
    link_detached: 'link detached house',
    lodge: 'lodge',
    longere: 'longère',
    maisonette: 'maisonette',
    mews: 'mews',
    office: 'office',
    park_home: 'mobile/park home',
    parking: 'parking',
    pub_bar: 'pub/bar',
    restaurant: 'restaurant',
    retail: 'retail',
    riad: 'riad',
    semi_detached: 'semi-detached house',
    semi_detached_bungalow: 'semi-detached bungalow',
    studio: 'studio',
    terraced: 'terraced house',
    terraced_bungalow: 'terraced bungalow',
    town_house: 'town house',
    villa: 'villa',
    warehouse: 'warehouse'
};

function formatPropertyType(propertyType?: string | null) {
    return propertyType ? propertyTypes[propertyType] : 'property';
}

const getListingTitle = (listingJson: {
    /*  The logic is adapted from mapTitle:
 https://gitlab.com/zoopla/future-velocity/api/api-graphql-lambda/-/blob/master/src/listing-details/mappers/mapTitle.ts#L122
    */
    property_type?: string;
    total_bedrooms?: number;
    pricing?: { transaction_type?: string };
    serviced?: boolean;
    category?: string;
    shared_accommodation?: boolean;
    derived?: {
        buyer_incentives?: string[] | undefined;
        retirement?: boolean | undefined;
        shared_accommodation?: boolean | undefined;
    };
}) => {
    const isListingCommercial = listingJson.category === 'commercial';

    const transactionTypeLabel =
        listingJson.pricing?.transaction_type === 'sale'
            ? 'for sale'
            : isListingCommercial
            ? 'to let'
            : 'to rent';
    if (listingJson.property_type === 'studio') {
        return 'Studio ' + transactionTypeLabel;
    }

    const sharedAccommodation =
        listingJson.shared_accommodation ??
        listingJson.derived?.shared_accommodation;

    if (sharedAccommodation && (listingJson.total_bedrooms ?? 0) <= 1) {
        return 'Room ' + transactionTypeLabel;
    }

    const propertyLabel = formatPropertyType(listingJson.property_type);

    if (listingJson.serviced) {
        return 'Serviced ' + propertyLabel + ' ' + transactionTypeLabel;
    }

    const numOfBedrooms = listingJson.total_bedrooms || 0;

    const propertyType = listingJson.property_type || '';

    const isResidentialPropertyTypeWithBedrooms =
        numOfBedrooms &&
        !isListingCommercial &&
        propertyType !== 'land' &&
        propertyType !== 'studio' &&
        propertyLabel !== 'room';

    const numOfBedsLabel = isResidentialPropertyTypeWithBedrooms
        ? numOfBedrooms + ' bed'
        : '';

    const titleArray = [];
    if (numOfBedsLabel) titleArray.push(numOfBedsLabel);
    titleArray.push(propertyLabel, transactionTypeLabel);

    const title = titleArray.join(' ');
    return title.charAt(0).toUpperCase() + title.slice(1);
};

function contentFromIncentive(incentive: string) {
    switch (incentive) {
        case 'equity_loan':
            return 'Equity loan';
        case 'fixed_price':
            return 'Fixed price';
        case 'from':
            return 'From';
        case 'guide_price':
            return 'Guide price';
        case 'non_quoting':
            return 'Non quoting';
        case 'offers_in_region_off':
            return 'Offers in region of';
        case 'offers_over':
            return 'Offers over';
        case 'part_buy_part_rent':
            return 'Part buy part rent';
        case 'sale_by_tender':
            return 'Sale by tender';
        case 'shared_equity':
            return 'Shared equity';
        case 'shared_ownership':
            return 'Shared ownership';
    }

    return null;
}

const getPropertyTenure = (summary: string | undefined) => {
    const tenureRegex = /(?:freehold|share\s*of\s*freehold|leasehold)/i;
    if (summary) {
        const tenureMatch = summary.match(tenureRegex);

        if (tenureMatch) {
            return tenureMatch[0];
        }
    }
};

const getTagsFromListingJson = (listingJson: {
    summary_description?: string;
    business_for_sale?: string;
    buyer_incentives?: string[];
    derived?: {
        buyer_incentives?: string[];
        retirement?: boolean;
        chain_free?: boolean | string;
        pricing?: {
            auction?: boolean;
        };
        pets_allowed?: boolean;
        shared_accommodation?: boolean;
        bills_included?: string[];
        porter_security?: boolean;
    };
    new_home?: boolean;
    retirement?: boolean;
    tenant_eligibility?: {
        students?: string;
    };
    pricing?: {
        auction?: boolean;
        transaction_type?: string;
        rent_values?: {
            per_month?: { price?: string };
            per_week?: { price?: string };
        };
        price?: number;
        price_qualifier?: string;
        pricing_history?: {
            price?: number;
            batch_creation_date?: string;
        }[];
    };
    house_shares?: boolean;
    premium?: {
        highlights?: { description?: string | null; label?: string }[];
        is_premium?: boolean;
    };
}) => {
    const {
        business_for_sale,
        buyer_incentives,
        derived,
        new_home,
        retirement,
        tenant_eligibility,
        pricing,
        premium = {}
    } = listingJson;
    const tags: { content: string }[] = [];

    const isPremiumListing = premium.is_premium;
    if (isPremiumListing) {
        return tags; // doesn't apply tags to a premium listing because they have highlited features selected by agent and which they pay for (i.e. large garden, private parking etc)
    }

    if (new_home) {
        tags.push({
            content: 'New home'
        });
    }
    const allBuyerIncentives = new Set([
        ...(Array.isArray(buyer_incentives) ? buyer_incentives : []),
        ...(derived?.buyer_incentives ? derived.buyer_incentives : [])
    ]);
    allBuyerIncentives.forEach((buyerIncentive) => {
        const content = contentFromIncentive(buyerIncentive);
        if (content) {
            tags.push({
                content
            });
        }
    });
    if (business_for_sale) {
        tags.push({
            content: 'Business for sale'
        });
    }
    if (tenant_eligibility?.students === 'accepted') {
        tags.push({
            content: 'Student friendly'
        });
    }

    if (retirement !== undefined ? retirement : derived?.retirement) {
        tags.push({
            content: 'Retirement'
        });
    }

    if (derived?.chain_free) {
        tags.push({
            content: 'Chain free'
        });
    }

    if (derived?.pets_allowed) {
        tags.push({
            content: 'Pets allowed'
        });
    }

    if (derived?.shared_accommodation) {
        tags.push({
            content: 'House share'
        });
    }

    if (derived?.bills_included) {
        if (
            derived.bills_included.includes('water') ||
            derived.bills_included.includes('electricity')
        ) {
            tags.push({
                content: 'Bills included'
            });
        } else {
            derived.bills_included.forEach((billType) => {
                tags.push({
                    content: `${billType} bill included`
                });
            });
        }
    }

    if (pricing?.auction || derived?.pricing?.auction) {
        tags.push({
            content: 'Auction'
        });
    }

    const summary = listingJson.summary_description;
    const propertyTenure = getPropertyTenure(summary);
    if (propertyTenure) {
        tags.push({
            content: propertyTenure
        });
    }

    return tags;
};

const getFeaturesWithIconNames = (listingJson: {
    bathrooms?: number;
    total_bedrooms?: number;
    living_rooms?: number;
}) => {
    const features = [];

    if (listingJson.bathrooms) {
        features.push({
            iconId: 'bath',
            content: listingJson.bathrooms
        });
    }

    if (listingJson.total_bedrooms) {
        features.push({
            iconId: 'bed',
            content: listingJson.total_bedrooms
        });
    }

    if (listingJson.living_rooms) {
        features.push({
            iconId: 'chair',
            content: listingJson.living_rooms
        });
    }

    return features;
};

const getFlag = ({
    life_cycle_status,
    pseudo_first_published_date
}: {
    life_cycle_status?: string;
    pseudo_first_published_date?: string;
}) => {
    const flags: { [key: string]: string } = {
        sold: 'Sold subject to contract',
        sale_under_offer: 'Under offer',
        rented: 'Let',
        rent_under_offer: 'Let agreed'
    };

    const flag = life_cycle_status ? flags[life_cycle_status] : null;

    if (flag) {
        return flag;
    }

    if (!pseudo_first_published_date) {
        return null;
    }

    const justAddedThreshold = new Date();
    justAddedThreshold.setDate(justAddedThreshold.getDate() - 3);

    if (new Date(pseudo_first_published_date) > justAddedThreshold) {
        return 'Just added';
    }

    return null;
};

const getHighlights = (listingJson: {
    premium?: {
        highlights?: { description?: string | null; label?: string }[];
    };
}) => {
    return (
        listingJson?.premium?.highlights?.map((highlight) => {
            return {
                description: highlight?.description ?? null,
                label: highlight?.label ?? null
            };
        }) ?? []
    );
};

const ZOOPLA_CONTENT_CDN = 'https://lid.zoocdn.com';
const generateContentUrl = (
    filename: string | undefined | null,
    width: number,
    height: number
): string | null => {
    if (filename) {
        return `${ZOOPLA_CONTENT_CDN}/${width}/${height}/${filename}`;
    } else {
        return null;
    }
};

const getMainImage = (listingJson: {
    content: { type?: string; filename?: string; caption?: string }[];
}) => {
    const firstImage = listingJson.content?.find(
        (content) => content.type === 'property_image'
    );

    if (!firstImage) {
        return null;
    }

    const image = {
        src: generateContentUrl(firstImage.filename, 645, 430),
        responsiveImgList: [
            [645, 430],
            [354, 255]
        ].map(([width, height]) => {
            return {
                width,
                src: generateContentUrl(firstImage.filename, width, height)
            };
        }),
        caption: firstImage?.caption ?? null
    };

    image.responsiveImgList = image.responsiveImgList?.filter((imageSize) =>
        Boolean(imageSize?.src)
    );

    return image;
};

const isNewHome = (listingJson: { new_home?: boolean }) => {
    return listingJson.new_home === true;
};

const isForSale = (listingJson: {
    pricing?: { transaction_type?: string };
}) => {
    if (!listingJson.pricing?.transaction_type) {
        return false;
    }

    return listingJson.pricing?.transaction_type === 'sale';
};

const isToRent = (listingJson: { pricing?: { transaction_type?: string } }) => {
    if (!listingJson.pricing?.transaction_type) {
        return false;
    }

    return listingJson.pricing?.transaction_type === 'rent';
};

const isCommercial = (listingJson: { category?: string }) => {
    return listingJson?.category === 'commercial';
};

const getListingUris = (listingJson: {
    listing_id?: number;
    new_home?: boolean;
    pricing?: { transaction_type?: string };
    category?: string;
}) => {
    if (!listingJson.listing_id) {
        return null;
    }

    let basePath = '/';

    if (isNewHome(listingJson)) {
        basePath += 'new-homes/';
    } else if (isForSale(listingJson)) {
        basePath += 'for-sale/';
    } else if (isToRent(listingJson)) {
        basePath += 'to-rent/';
    }

    if (isCommercial(listingJson) && isNewHome(listingJson) === false) {
        basePath += 'commercial/';
    }

    // Todo: Add support for overseas
    return {
        contact: `${basePath}contact/${listingJson?.listing_id}/`,
        detail: `${basePath}details/${listingJson?.listing_id}/`,
        success: `${basePath}contact/success/${listingJson?.listing_id}/`
    };
};

const getOtherPropertyImages = (listingJson: {
    content?: { type?: string; filename?: string }[];
}) => {
    const images = listingJson.content?.filter(
        (content) => content.type === 'property_image'
    );

    images?.shift();

    return (
        images?.reduce<{ small: string | null; large: string | null }[]>(
            (imgs, image) => {
                if (!image) {
                    return imgs;
                }

                imgs.push({
                    small: generateContentUrl(image.filename, 354, 255),
                    large: generateContentUrl(image.filename, 645, 430)
                });

                return imgs;
            },
            []
        ) ?? []
    );
};

const getLocation = (listingJson: {
    location?: { coordinates?: { latitude?: number; longitude?: number } };
}) => {
    return {
        coordinates: {
            isApproximate: false,
            latitude: listingJson.location?.coordinates?.latitude ?? null,
            longitude: listingJson.location?.coordinates?.longitude ?? null
        }
    };
};

function safeElide(text: string, limit: number) {
    let stripped = text.replace(/(<([^>]+)>)/gms, ' ');
    stripped = stripped.replace(/[ ]+/gms, ' ');
    return truncate(unescape(stripped), {
        length: limit,
        separator: ' ',
        omission: ' ...'
    });
}

function getSummaryDescription(listingJson: { summary_description?: string }) {
    if (listingJson.summary_description) {
        return safeElide(listingJson.summary_description, 150);
    } else {
        return null;
    }
}

const getTransport = (listingJson: {
    points_of_interest?: {
        transport?: {
            distance_miles?: string;
            features?: { tube_lines?: string };
            lat?: number;
            lng?: number;
            poiType?: string;
            title?: string;
        }[];
    };
}) =>
    listingJson.points_of_interest?.transport?.map((transport) => ({
        distanceInMiles: transport?.distance_miles,
        features: {
            tubeLines: transport?.features?.tube_lines,
            zone: transport?.features?.tube_lines
        },
        lat: transport?.lat,
        lng: transport?.lng,
        poiType: transport?.poiType,
        title: transport?.title
    })) || [];

type ListingJson = Listing & {
    content: {
        type?: string;
        filename?: string;
        caption?: string;
    }[];
    is_live?: boolean;
    pricing?: {
        auction?: boolean;
        transaction_type?: string;
        rent_values?: {
            per_month?: { price?: string };
            per_week?: { price?: string };
        };
        price?: number;
        price_qualifier?: string;
        pricing_history?: {
            price?: number;
            batch_creation_date?: string;
        }[];
    };
    branch_id?: number;
    branch?: {
        branch_details_uri?: string;
        logo_url?: string;
        branch_name?: string;
        redirect_commercial_phone?: string; // TODO: get example
        redirect_lettings_phone?: string;
        redirect_phone?: string;
    };
    house_shares?: boolean;
    category?: string;
    display_address?: string;
    pseudo_first_published_date?: string;
    available_from_date?: string;
    business_for_sale?: string;
    buyer_incentives?: string[];
    derived?: {
        chain_free?: boolean | string;
        buyer_incentives?: string[];
        retirement?: boolean;
        pricing?: {
            auction?: boolean;
        };
        pets_allowed?: boolean;
        shared_accommodation?: boolean;
        bills_included?: string[];
        porter_security?: boolean;
    };
    new_home?: boolean;
    retirement?: boolean;
    tenant_eligibility?: {
        students?: string;
    };
    featured_type?: string;
    bathrooms?: number;
    total_bedrooms?: number;
    living_rooms?: number;
    premium?: {
        highlights?: {
            description?: string | null;
            label?: string;
        }[];
        is_premium?: boolean;
    };
    last_published_date?: string;
    listing_id?: number;
    location?: {
        coordinates?: {
            latitude?: number;
            longitude?: number;
        };
    };
    summary_description?: string;
    property_type?: string;
    points_of_interest?: {
        transport?: {
            distance_miles?: string;
            features?: { tube_lines?: string };
            lat?: number;
            lng?: number;
            poiType?: string;
            title?: string;
        }[];
    };
};

const mapListingJsonToInternalViewModelListing = (listingJson: ListingJson) => {
    const { numberOfVideos, numberOfImages, numberOfFloorPlans } =
        getMediaContentCount(listingJson);

    return {
        address: listingJson.display_address ?? null,
        alternativeRentFrequencyLabel:
            getAlternativeRentFrequencyLabel(listingJson),
        availableFrom: listingJson.available_from_date
            ? dateStringResolver(new Date(listingJson.available_from_date))
            : '',
        branch: {
            branchId: listingJson.branch_id ?? null,
            branchDetailsUri: listingJson.branch?.branch_details_uri ?? null,
            logoUrl: listingJson.branch?.logo_url ?? null,
            name: listingJson.branch?.branch_name ?? null,
            phone: getCorrectPhoneForListing(listingJson) ?? null
        },
        displayType: getVariant(listingJson),
        featuredType: listingJson.featured_type ?? null,
        features: getFeaturesWithIconNames(listingJson),
        flag: getFlag(listingJson),
        highlights: getHighlights(listingJson),
        image: getMainImage(listingJson),
        isPremium: listingJson.premium?.is_premium ?? false,
        // isNewHomesDevelopment: 'tbc',
        lastPublishedDate: listingJson.last_published_date ?? null,
        listingId: String(listingJson.listing_id),
        listingUris: getListingUris(listingJson),
        location: getLocation(listingJson),
        numberOfFloorPlans,
        numberOfImages,
        numberOfVideos,
        //numberOfViews: "no longer unsupported",
        otherPropertyImages: getOtherPropertyImages(listingJson),
        price: getPrice2(listingJson),
        priceDrop: getPriceDrop(listingJson),
        priceTitle: getPriceTitle(listingJson),
        propertyType: listingJson.property_type ?? null,
        publicationStatus: listingJson.is_live ? 'Live' : 'Expired',
        publishedOn: listingJson.pseudo_first_published_date
            ? dateStringResolver(
                  new Date(listingJson.pseudo_first_published_date)
              )
            : '',
        publishedOnLabel: 'Listed on',
        shortPriceTitle: buildShortPriceTitle(
            listingJson.pricing?.price_qualifier || '',
            listingJson.pricing?.price ?? 0
        ),
        summaryDescription: getSummaryDescription(listingJson),
        tags: getTagsFromListingJson(listingJson),
        title: getListingTitle(listingJson),
        transports: getTransport(listingJson).slice(0, 2)
    };
};

const MAX_SEARCH_PAGES = 40;

// cost: ~7ms
const mapPagination = ({
    total,
    totalWasLimited,
    path
}: {
    total: number;
    totalWasLimited: boolean;
    path: string;
}) => {
    const pageSize = getPageSize(path);
    const { urlParameters } = getUrlFromPath(path);

    const pageNumberMax =
        total && total >= pageSize
            ? Math.min(Math.ceil(total / pageSize), MAX_SEARCH_PAGES)
            : 1;
    const pageNumberParam = Number(urlParameters.get('pn'));
    const pageNumber =
        pageNumberParam && !isNaN(pageNumberParam) && pageNumberParam > 0
            ? Math.min(pageNumberParam, pageNumberMax)
            : 1;

    return {
        totalResults: total,
        totalResultsWasLimited: totalWasLimited,
        pageNumber: pageNumber,
        pageNumberMax: pageNumberMax
    };
};

// TODO: autogen
type GeoDataServiceResponse = {
    geoData: {
        aliasId: number;
        areaId: number;
        areaName: string;
        areaStreetId: number;
        coordinates: { lat: number; lng: number };
        countryId: number;
        countyAreaId: number;
        countyAreaName: string;
        disambiguatedAreas?: [
            {
                aliasId: number;
                areaId: number;
                countyAreaId: number;
                identifier: string;
                label: string;
                lat: number;
                lng: number;
                postTownId: number;
            }
        ];
        entityIdField: string;
        geoType: string;
        identifier: string;
        laCode: string | null;
        level: number;
        outcode: string | null;
        polygons: {
            '0': GeoJsonAnyPolygon;
            '1': GeoJsonAnyPolygon;
            '3': GeoJsonAnyPolygon;
            '5': GeoJsonAnyPolygon;
            '10': GeoJsonAnyPolygon;
            '15': GeoJsonAnyPolygon;
            '20': GeoJsonAnyPolygon;
            '30': GeoJsonAnyPolygon;
            '40': GeoJsonAnyPolygon;
            '0.25': GeoJsonAnyPolygon;
            '0.5': GeoJsonAnyPolygon;
        };
        postTownId: number;
        postalArea: string | null;
        regionId: number;
        regionName: string;
    };
    status: number;
};

type SearchPreferences = {
    fields?: string[];
    featured?: boolean;
};

export async function createSearchRequest(
    path: string,
    geoDataResponse: GeoDataServiceResponse,
    preferences?: SearchPreferences
) {
    const searchRequestObject = mapSearchUrlToSearchServiceParameters(
        path,
        preferences?.fields
    );

    const polyEncValues = getPolyEncParameters(
        path,
        searchRequestObject.parameters?.radius ?? null
    );

    let geoParameters;
    if (polyEncValues) {
        geoParameters = await getPolygonFromPolyEncSearchArgs(polyEncValues);
    } else {
        geoParameters = mapGeoDataToSearchArgs(
            geoDataResponse,
            searchRequestObject.parameters?.radius
        );
    }

    const initialSearchRequest: SearchServiceRequest = {
        from: searchRequestObject.from,
        size: searchRequestObject.size,
        sort: searchRequestObject.sort,
        fields: searchRequestObject.fields,
        featured: preferences?.featured ?? true, // defaulted to true in BFF
        parameters: {
            ...searchRequestObject.parameters,
            ...geoParameters
        }
    };

    if (!polyEncValues) {
        // don't auto-extend drawn polygons searches
        // setup a fallback search for extended results if possible
        initialSearchRequest.extended = generateFallbackExtendedSearch(
            initialSearchRequest,
            geoDataResponse
        );
    }

    return initialSearchRequest;
}

export function mapSearchResponse(
    path: string,
    responses: { geo: GeoDataServiceResponse; search: SearchServiceResponse }
) {
    const searchIdentifier = generateSearchIdentifier(path);

    const at = getAnalyticsTaxonomy({
        geoData: responses.geo.geoData,
        response: responses.search,
        requestUrl: path,
        resultsSort: '',
        searchGuid: '',
        searchIdentifier: searchIdentifier
    });

    return {
        // can we compress this?
        adTargeting: {
            activity: at.activity,
            areaName: at.areaName,
            bedsMax: at.bedsMax,
            bedsMin: at.bedsMin,
            brand: at.brand,
            brandPrimary: at.brand,
            countryCode: at.countryCode,
            countyAreaName: at.countyAreaName,
            currencyCode: at.currencyCode,
            listingsCategory: at.listingsCategory,
            outcode: at.outcode,
            outcodes: at.outcodes,
            page: at.page,
            postalArea: at.postalArea,
            priceMax: at.priceMax,
            priceMin: at.priceMin,
            regionName: at.regionName,
            // resultsSort: sortOrder?.currentSortOrder, TODO: check with Elliot, can drop
            searchLocation: at.searchLocation,
            searchResultsCount: at.searchResultsCount,
            section: at.section,
            totalResults: at.totalResults,
            url: at.url,
            viewType: at.viewType
        },
        // has to be on page load
        analyticsEcommerce: getAnalyticsEcommerce(responses.search),
        // has to be on page load
        analyticsTaxonomy: at,
        // filters: {},
        links: {},
        listings: {
            regular:
                responses.search.listings?.map(
                    mapListingJsonToInternalViewModelListing
                ) ?? null,
            extended:
                responses.search.extended_listings?.map(
                    mapListingJsonToInternalViewModelListing
                ) ?? null,
            featured:
                responses.search.featured_listings?.map(
                    mapListingJsonToInternalViewModelListing
                ) ?? null
        },
        // metaInfo: {},
        pagination: mapPagination({
            total: responses.search.total,
            totalWasLimited: responses.search.total_was_limited ?? false,
            path
        }),
        // polyenc: '',
        // savedSearchAndAlerts: {},
        seoBlurb: {
            transactionType: null
        },
        // sortOrder: {},
        // title: '',
        userAlertId: ''
    };
}

export async function searchRequest(
    path: string,
    preferences?: SearchPreferences
) {
    if (
        !process.env.API_GEO_LOCATION ||
        !process.env.API_GEO_LOCATION_SECRET ||
        !process.env.SEARCH_SERVICE_SECRET
    ) {
        throw new Error(
            'Missing envar. Requires: ' +
                `API_GEO_LOCATION "${process.env.API_GEO_LOCATION}", ` +
                `API_GEO_LOCATION_SECRET "${process.env.API_GEO_LOCATION_SECRET}" and ` +
                `SEARCH_SERVICE_SECRET "${process.env.SEARCH_SERVICE_SECRET}"`
        );
    }

    const geoId = getSearchLocationFromPath(path);

    // Can we remove the ~9 fields from here?
    const geoUrl = new URL(`${process.env.API_GEO_LOCATION}/api/v1/geo-data`);
    geoUrl.searchParams.append('q', geoId);
    geoUrl.searchParams.append('with', 'polygons');

    // Can we remove this somehow?
    let geoDataResponse;

    try {
        geoDataResponse = await fetch<GeoDataServiceResponse>({
            url: geoUrl,
            secret: process.env.API_GEO_LOCATION_SECRET
        });
    } catch (e) {
        throw new Error('GEO_ERROR', { cause: { geoId } });
    }

    //handle an ambiguous geo response
    if (geoDataResponse.geoData.disambiguatedAreas) {
        throw new Error('AMBIGUOUS_GEO_ERROR', { cause: { geoId } });
    }

    const searchRequest = await createSearchRequest(
        path,
        geoDataResponse,
        preferences
    );

    const searchUrl = new URL(`${process.env.SEARCH_SERVICE}/listings/_search`);
    // response is camelized in BFF but the whole response is remapped anyway
    // so we can skip the work and it's easier to type
    const searchResponse = await fetch<SearchServiceResponse>(
        {
            url: searchUrl,
            secret: process.env.SEARCH_SERVICE_SECRET
        },
        JSON.stringify(searchRequest)
    );

    return { searchResponse, geoDataResponse };
}

export async function uiSearch(path: string): Promise<SearchResults> {
    const { searchResponse, geoDataResponse } = await searchRequest(path);

    return mapSearchResponse(path, {
        geo: geoDataResponse,
        search: searchResponse
    });
}
